import { Component, OnInit } from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PremiumOverDueHandlerComponent } from './premium-over-due.handler';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { OfflineService } from 'src/app/offline/offline.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sym-premium-over-due',
  templateUrl: './premium-over-due.component.html',
  imports: [CommonModule],
  styleUrls: ['./premium-over-due.component.scss'],
})
export class PremiumOverDueComponent extends PremiumOverDueHandlerComponent implements OnInit {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }
}
